<style lang="sass">
.sms-button
  display: inline-block
  line-height: 1.5em
  padding: 4px 16px
  border-radius: 6px
  font-size: 16px
  text-decoration: none
  text-align: center
  font-weight: 400
  cursor: pointer
  outline: none
  background: #fff
  color: #50bfff
  border: 1px solid #50bfff
  transition: all .3s ease
  &:hover
    color: #20a0ff
    border: 1px solid #20a0ff
    text-decoration: none
  &.major
    color: #fff
    background: #20a0ff
    border-color: #20a0ff
    &:hover
      background: #4db3ff
      border-color: #4db3ff
  &.small
    font-size: 12px
    padding: 4px 12px
    border-radius: 4px
  &.large
    font-size: 20px
    padding: 4px 20px
</style>

<template lang="pug">
a.sms-button(v-if="target", target="_blank", :href="url", :class="[type, buttonSize]")
  slot
router-link.sms-button(v-else-if="link", :to="url", :class="[type, buttonSize]")
  slot
.sms-button(v-else, :class="[type, buttonSize]")
  slot
</template>

<script>
export default {
  props: {
    target: null,
    link: null,
    type: {
      default: null
    },
    url: {
      default: null
    },
    size: null
  },
  computed: {
    buttonSize: function () {
      if (this.size === 'small') return 'small'
      else if (this.size === 'large') return 'large'
    }
  }
}
</script>



// WEBPACK FOOTER //
// sms_button.vue?078a2720